'use strict';

export const ANIMATION_SCROLL_TIME = 500;

export const ABOUT_PAGE = {
    MODULES: {
        ABOUT_HERO: 'hero',
        ABOUT_BIO: 'aboutMeBio',
        ABOUT_ORG_CUSTOM_CONTENT: 'orgCustomContent',
        ABOUT_USER_CUSTOM_CONTENT: 'userCustomContent',
        ABOUT_LOCATIONS: 'locations',
        ABOUT_CONTACT_FORM: 'contactForm',
        ABOUT_TEAM: 'team'
    },
    URL_PATHS: {
        ABOUT: 'about',
        ABOUT_ME: 'about-me'
    }
};

export const ABOUT_ME_BIO = {
    ABOUT_ME_HEADERS: {
        ABOUT_ME: 'About Me',
        ABOUT_US: 'About Us'
    }
};

export const CAREERS_PAGE = {
    CAREERS_URL_PATH: 'careers',
    MODULES: {
        CAREERS_HERO: 'hero',
        CAREERS_CUSTOM_CONTENT: 'orgCustomContent',
        CAREERS_CUSTOM_CONTENT_TWO: 'orgCustomContentTwo',
        CAREERS_CUSTOM_CONTENT_THREE: 'orgCustomContentThree',
        CAREERS_PAGE_USER_CUSTOM_CONTENT: 'userCustomContent',
        CONTACT_FORM: 'contactForm'
    }
};

export const CONTACT_FORM = {
    CONTACT_BUTTON_TEXT: 'Contact Me',
    CUSTOM_FIELDS: {
        FIRST_NAME: 'first_name',
        LAST_NAME: 'last_name'
    },
    CUSTOM_POST_DATA: {
        TITLE: 'Additional Information',
        DESCRIPTION: 'The follow is additional information from the contact request:'
    },
    EVENT_CUSTOM_DATA: {
        TITLE: 'Event Information',
        DESCRIPTION: 'This form submission came from an event page. See the event details below:'
    },
    DEFAULT_PROPS: {
        CONTACT_LABEL: 'Contact',
        SUBMISSION_SUCCESS_TITLE: 'Thank you',
        SUBMISSION_SUCCESS: 'We\'ve Received Your Request.'
    },
    ERROR_MSG: 'Please fill out this field.',
    FIELD_TYPES: ['text', 'tel', 'email', 'textarea', 'select', 'image'],
    STANDARD_FIELDS: ['name', 'phone', 'email', 'comments']
};

export const ERROR_PAGE = {
    ERROR_PAGE_TEXT: 'Take Me Home'
};

export const EVENT_LIST = {
    DEFAULT_PROPS: {
        LABEL_RSVP: 'RSVP',
        LABEL_RSVP_BUTTON: 'Register',
        LABEL_DETAILS_BUTTON: 'Details',
        SHOW_HEADER: false,
        IS_EVENT_DETAILS_ENABLED: false
    }
};

export const EVENTS_PAGE = {
    MODULES: {
        EVENTS_HERO: 'hero',
        EVENTS_ORG_CUSTOM_CONTENT: 'orgCustomContent',
        EVENTS_USER_CUSTOM_CONTENT: 'userCustomContent',
        EVENT_LIST: 'events',
        EVENTS_CONTACT_FORM: 'contactForm'
    }
};

export const EVENT_PAGE = {
    MODULES: {
        EVENT_HERO: 'hero',
        EVENT_DETAILS: 'eventDetails',
        EVENT_CONTACT_FORM: 'contactForm'
    },
    DEFAULT_PROPS: {
        LABEL_RSVP: 'RSVP',
        LABEL_RSVP_BUTTON_TEXT: 'RSVP'
    }
};

export const GENERAL = {
    BROKER_CHECK: {
        TEXT: 'Check the background of this advisor on ',
        ANCHOR_TEXT: 'FINRA\'s BrokerCheck,',
        ANCHOR_URL: 'http://brokercheck.finra.org/',
        ANCHOR_TITLE: 'Visit FINRA\'s brokercheck site.'
    },
    CONTACT: {
        PHONE: 'Phone',
        EMAIL: 'E-mail',
        ADDRESS: 'Address'
    }
};

export const HOME_PAGE = {
    MODULES: {
        HOME_PROFILE: 'profile',
        HOME_LOCATIONS: 'locations',
        HOME_PRODUCTS: 'products',
        HOME_EMAIL_SUBSCRIPTION: 'emailSubscription',
        HOME_REVIEW_TRACKER: 'reviewTracker',
        HOME_ORG_CUSTOM_CONTENT: 'orgCustomContent',
        HOME_ORG_CUSTOM_CONTENT_TWO: 'orgCustomContentTwo',
        HOME_ORG_CUSTOM_CONTENT_THREE: 'orgCustomContentThree',
        HOME_USER_CUSTOM_CONTENT: 'userCustomContent',
        MORTGAGE_CALCULATOR: 'mortgageCalculator',
        CONTACT_FORM: 'contactForm',
        HOME_NEWS: 'news',
        HOME_EVENTS: 'events',
        HOME_TEAM: 'team'
    },
    VISIBLE_EVENTS: 3,
    VISIBLE_POSTS: 3
};

export const LOCATIONS = {
    OFFICE_ADDRESS_FIELDS: ['street', 'suite', 'city', 'state', 'country', 'zipCode'],
    LABELS: {
        PHONE: 'Phone',
        FAX: 'Fax',
        TOLL_FREE: 'Toll Free',
        CELL: 'Cell',
        EMAIL: 'Email',
        OFFICE_HOURS: 'Hours',
        ADDRESS: 'Address',
        HEADER_MULTIPLE_SUBOFFICES: 'Offices',
        HEADER_SINGLE_SUBOFFICE: 'Office'
    },
    DEFAULT_PROPS: {
        SUBOFFICES: []
    }
};

export const NAVIGATION = {
    SCREEN_READER_ONLY_NAV_TEXT: 'Toggle navigation',
    DEFAULT_PROPS: {
        NAVIGATION_CLOSE_BUTTON: 'Close',
        NAVIGATION_CONTACT_LABEL: 'Contact'
    },
    SELECTOR: {
        CONTAINER: '.sidr-body'
    },
    CLASS_NAME: {
        CLOSE: 'sidr-close',
        OPEN: 'sidr-open'
    }
};

export const NEWS_PAGE = {
    MODULES: {
        NEWS_HERO: 'hero',
        NEWS_ORG_CUSTOM_CONTENT: 'orgCustomContent',
        NEWS_USER_CUSTOM_CONTENT: 'userCustomContent',
        NEWS_CONTACT_FORM: 'contactForm',
        NEWS: 'news'
    }
};

export const POST_LIST = {
    DEFAULT_PROPS: {
        SHOW_HEADER: false,
        HIDE_OVERLAY: false
    }
};

export const POST_UTILS = {
    DEFAULT_PROPS: {
        OVERLAY_SYMBOL: 'eye',
        OVERLAY_TEXT: 'Read Post',
        HREF: '#!',
        CLASS_NAME: '',
        TARGET: '_self'
    },
    POST_MODAL_ANCHOR_TITLE: 'Close this modal'
};

export const PRODUCT_LIST = {
    DEFAULT_PROPS: {
        SHOW_HEADER: false
    }
};

export const PRODUCT_PAGE = {
    MODULES: {
        PRODUCTS_HERO: 'PRODUCTS_HERO',
        PRODUCTS_ORG_CUSTOM_CONTENT: 'PRODUCTS_ORG_CUSTOM_CONTENT',
        PRODUCTS_USER_CUSTOM_CONTENT: 'PRODUCTS_USER_CUSTOM_CONTENT',
        PRODUCT_LIST: 'PRODUCT_LIST',
        CONTACT_FORM: 'CONTACT_FORM'
    }
};

export const PROFILE = {
    LABELS: {
        STATES_LICENSING: 'States Licensed',
        AREAS_SERVED: 'Areas Served',
        LANGUAGES: 'Languages Spoken'
    }
};

export const PROFILE_BUTTON = {
    DEFAULT_PROPS: {
        OPEN_IN_NEW_WINDOW: false
    }
};

export const SECTION_HEADER = {
    BUTTON_TEXT: 'See all'
};

export const SOCIAL_ICONS = {
    ICON_MAP: {
        facebook: 'fa-facebook-official',
        twitter: 'fa-twitter-square',
        linkedin: 'fa-linkedin-square',
        instagram: 'fa-instagram',
        yelp: 'fa-yelp-square'
    }
};

export const TEAM_MEMBER = {
    CALL_ME_TEXT: 'Call me',
    EMAIL_ME_TEXT: 'Email me'
};

export const TEAM_MEMBERS = {
    ASSOCIATED_OFFICE: 'office_0',
    HEADER_TEXT: 'My Team',
    LABELS: {
        JOB_TITLE: 'Job Title',
        STATE_LICENSES: 'State Licenses',
        LOCATION: 'Location',
        WEBSITE: 'Website',
        EMAIL: 'E-mail',
        PHONE: 'Phone',
        FAX: 'Fax'
    }
};

export const AFFIX = {
    DEFAULT_OFFSET: 0
};



// WEBPACK FOOTER //
// ./components/constants.js